(function () {
  var WEBHOOK_BASE_URL = 'https://mementoexclusives.app.n8n.cloud/webhook/Form-Submission';
  var WEBHOOK_TOKEN = 'f1a_me_webhook_R3g7Cp_9vK42mQx7LpN8sTd5HrY1cZw6BjU4nEa';
  var ALLOWED_FORM_IDS = ['XRg8A7', 'Tzcj4F', 'UbABU4', 'Vt9aLM', 'SEWwab'];
  var STORAGE_KEY = 'pdpv3_klaviyo_webhook_attribution';
  var COOKIE_DAYS = 90;

  var TRACKING_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'gclid',
    'gbraid',
    'wbraid',
    'fbclid',
    'msclkid',
    'li_fat_id'
  ];

  function sanitize(value) {
    if (!value) return '';
    return String(value).trim().replace(/[<>"'`]/g, '').substring(0, 255);
  }

  function getWebhookUrl() {
    return WEBHOOK_BASE_URL + '?token=' + encodeURIComponent(WEBHOOK_TOKEN);
  }

  function getCustomerPrivacy() {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      return window.Shopify.customerPrivacy;
    }
    return null;
  }

  function marketingConsentAllowed() {
    var customerPrivacy = getCustomerPrivacy();

    if (!customerPrivacy || typeof customerPrivacy.marketingAllowed !== 'function') {
      return false;
    }

    try {
      return !!customerPrivacy.marketingAllowed();
    } catch (error) {
      return false;
    }
  }

  function getCookie(name) {
    try {
      var match = document.cookie.match(new RegExp('(^|; )' + name + '=([^;]*)'));
      return match ? decodeURIComponent(match[2]) : '';
    } catch (error) {
      return '';
    }
  }

  function setCookie(name, value, days) {
    try {
      if (!value) return;

      var expires = '';
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
      }

      document.cookie =
        name +
        '=' +
        encodeURIComponent(value) +
        expires +
        '; path=/; SameSite=Lax';
    } catch (error) {}
  }

  function readStoredAttribution() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return {};

      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  function writeStoredAttribution(data) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (error) {}
  }

  function getFacebookAttribution(params) {
    var fbp = sanitize(getCookie('_fbp'));
    var fbc = sanitize(getCookie('_fbc'));
    var fbclid = sanitize(params.get('fbclid'));

    if (!fbc && fbclid) {
      fbc = 'fb.1.' + Date.now() + '.' + fbclid;
    }

    return {
      fbp: fbp,
      fbc: fbc
    };
  }

  function getTrackingValue(key, params, storedAttribution) {
    var liveValue = sanitize(params.get(key));
    if (liveValue) return liveValue;

    var cookieValue = sanitize(getCookie(key));
    if (cookieValue) return cookieValue;

    return sanitize(storedAttribution[key]);
  }

  function captureAttributionFromUrlAndCookies() {
    if (!marketingConsentAllowed()) return;

    var params = new URLSearchParams(window.location.search);
    var stored = readStoredAttribution();
    var next = Object.assign({}, stored);
    var changed = false;

    TRACKING_KEYS.forEach(function (key) {
      var liveValue = sanitize(params.get(key));
      var cookieValue = sanitize(getCookie(key));
      var value = liveValue || cookieValue;

      if (!value) return;

      if (next[key] !== value) {
        next[key] = value;
        changed = true;
      }

      setCookie(key, value, COOKIE_DAYS);
    });

    var facebookAttribution = getFacebookAttribution(params);

    if (facebookAttribution.fbp && next.fbp !== facebookAttribution.fbp) {
      next.fbp = facebookAttribution.fbp;
      changed = true;
      setCookie('fbp', facebookAttribution.fbp, COOKIE_DAYS);
    }

    if (facebookAttribution.fbc && next.fbc !== facebookAttribution.fbc) {
      next.fbc = facebookAttribution.fbc;
      changed = true;
      setCookie('fbc', facebookAttribution.fbc, COOKIE_DAYS);
    }

    if (changed) {
      writeStoredAttribution(next);
    }
  }

  function buildPayload(detail) {
    var consented = marketingConsentAllowed();
    var params = new URLSearchParams(window.location.search);
    var storedAttribution = readStoredAttribution();

    var payload = {
      formId: sanitize(detail.formId || detail.formID || ''),
      companyId: sanitize(detail.companyId || ''),
      eventType: sanitize(detail.type || ''),
      submittedAt: new Date().toISOString(),
      pagePath: window.location.pathname,
      pageTitle: document.title || '',
      metaData: detail.metaData || {}
    };

    if (consented) {
      payload.pageUrl = window.location.href;
      payload.referrer = document.referrer || '';

      TRACKING_KEYS.forEach(function (key) {
        var value = getTrackingValue(key, params, storedAttribution);

        if (value) {
          payload[key] = value;
        }
      });

      var facebookAttribution = getFacebookAttribution(params);

      if (facebookAttribution.fbp) {
        payload.fbp = facebookAttribution.fbp;
      } else if (storedAttribution.fbp) {
        payload.fbp = sanitize(storedAttribution.fbp);
      } else if (getCookie('fbp')) {
        payload.fbp = sanitize(getCookie('fbp'));
      }

      if (facebookAttribution.fbc) {
        payload.fbc = facebookAttribution.fbc;
      } else if (storedAttribution.fbc) {
        payload.fbc = sanitize(storedAttribution.fbc);
      } else if (getCookie('fbc')) {
        payload.fbc = sanitize(getCookie('fbc'));
      }
    } else {
      payload.pageUrl = window.location.origin + window.location.pathname;
      payload.referrer = '';
    }

    return payload;
  }

  function sendWebhook(payload) {
    var body = JSON.stringify(payload);
    var webhookUrl = getWebhookUrl();

    try {
      fetch(webhookUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        },
        body: body,
        keepalive: true
      });
    } catch (error) {}
  }

  function handleKlaviyoSubmit(event) {
    if (!event || !event.detail) return;
    if (event.detail.type !== 'submit') return;

    var formId = String(event.detail.formId || event.detail.formID || '').trim();
    if (ALLOWED_FORM_IDS.indexOf(formId) === -1) return;

    var payload = buildPayload(event.detail);
    sendWebhook(payload);
  }

  function init() {
    captureAttributionFromUrlAndCookies();

    window.addEventListener('klaviyoForms', handleKlaviyoSubmit);

    document.addEventListener('visitorConsentCollected', function () {
      captureAttributionFromUrlAndCookies();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();